import { Injectable } from '@angular/core';
import { delay } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAuthHttpService } from './auth-http-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpServiceFake implements IAuthHttpService {
  public postExchangeToken() {
    return of('token_producer_qui_remplace_token_abc').pipe(delay(2000));
  }

  public postSendVerificationCode() {
    return of({
      status: 'Verification successful',
      data: {
        token: 'new_auth_token_after_verification',
        token_producer: null
      }

    }).pipe(delay(2000));
  }

  public requestCode() {
    return of().pipe(delay(2000));
  }
}
